import React, { FC } from 'react'
import _ from 'lodash'
// Data
import { parseDate } from "data/lib/dates"
import { localizeNum, isValidNumber } from "data/lib/numbers"
import { formatDate, isValidDate } from 'data/lib/dates'
import propertyService from 'data/property'
// Styles
import { Label_s } from 'styles/app-styles'
import { MultipleRow_s } from 'components/table/hovers/hover-styles'

type IRecoveryPoolsHover = {
  config: {},
  data: [],
  tenantContributionsData: object[],
  lineItemData: object[],
  state: string
}

const RecoveryPoolsHover: FC<IRecoveryPoolsHover> = (props) => {
  const state = props.state === 'detailed' ? 'lineItemDetailed' : props.state
  let expenseItems = _.get(props, "data.recoverypooldetail.expenseItems.lineItems") || []
  let tenantContributionItems = _.get(props, "data.recoverypooldetail.tenantContributionItems.items") || []
  let expenseCount = expenseItems.length
  let tenantCount = tenantContributionItems.length
  if (expenseItems.length > 3) expenseItems = expenseItems.slice(0, 3);
  if (tenantContributionItems.length > 3) tenantContributionItems = tenantContributionItems.slice(0, 3);

  const renderValue = (dataItem: object, configItem: {key: string, label: string}) => {
    let val:any|null = null
    if (Array.isArray(configItem.key)){
      for (let i of configItem.key){
        if(i === "lineItemId") {
          const lineItem = _.find(props.lineItemData, { lineitemid: dataItem[i] })
          val = `Expense: ${_.get(lineItem, "code")}`
        } else if (i === "tenantContributionNamedItemId") {
          const tenantContribution = _.find(props.tenantContributionsData, { tenantcontributionid: dataItem[i] })
          val = `Tenant Contrib: ${_.get(tenantContribution, "code")}`
        } else {
          val = val ? val[i] : dataItem[i]
        }
      }
    } else val = dataItem[configItem.key]
    // If date, show MM/YYYY date
    if (isValidDate(val)){
      val = formatDate(val, 'MM/YYYY');
    }
    // If named item, show code
    if (configItem.key[configItem.key.length - 1] === 'areaMeasureNamedItemId' && val){
      val = _.find(props["areaMeasuresData"], { areaid: val });
      val = val ? val.code : ""
    }
    if (configItem.key === 'lineItemId' && val){
      val = _.find(props["lineItemData"], { lineitemid: val }) || _.find(props["systemLineItemData"], { systemlineitemid: val});
      val = val ? val.code : ""
    }
    // If number, show 4 digits of precision
    if (isValidNumber(val)){
      val =`${localizeNum(val, 4)}`
    }
    // If boolean, display textual representation of value
    if(_.isBoolean(val)){
      if(val) val = "True"
      else val = "False"
    }

    return (
      <td>
        { val && <span>{ val }</span> }
      </td>
    )
  }

  return (
    <div>
      <MultipleRow_s>
        <table>
          <thead>
            { _.map(_.get(props, "config.recoverypooldetail.expenseItems"), key => {
              return (
                <th>
                  <Label_s>{ key.label }</Label_s>
                </th>
              )
            }) }
          </thead>
          { _.get(props, "config.recoverypooldetail.expenseItems") && expenseItems.map(item => {
            return (
              <tr>
                { _.map(_.get(props, "config.recoverypooldetail.expenseItems"), key => renderValue(item, key))}
              </tr>
            )
          }) }
          { _.get(props, "config.recoverypooldetail.tenantContributions") && tenantContributionItems.map(item => {
            return (
              <tr>
                { _.map(_.get(props, "config.recoverypooldetail.tenantContributions"), key => renderValue(item, key))}
              </tr>
            )
          }) }
        </table>
        { (expenseCount > 3 || tenantCount > 3) && <div style={{marginLeft: 'auto', textAlign: 'right'}}><strong>...</strong></div>}
      </MultipleRow_s>
    </div>
  )
}

export default RecoveryPoolsHover
